"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInsightsSink = void 0;
const applicationinsights_react_js_1 = require("@microsoft/applicationinsights-react-js");
const applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
const Log = __importStar(require("../Log"));
const types_1 = require("./types");
/**
 * AppInsightsSink is responsible for forwarding Log.* statements on to
 * AppInsights. You can use one of 2 approaches with this sink, either
 *
 * - a full browser-tracing enabled sink without sampling, which will capture pageviews
 *     and 100% of any log statements
 *
 * - a sampled sink that will only send debug logs at the desired sampling rate
 */
class AppInsightsSink extends types_1.LogSink {
    constructor(logLevelLimit, options) {
        var _a;
        super(Object.assign({}, logLevelLimit));
        this.appInsights = null;
        try {
            // create either a sampled debug AppInsights instance, or a regular one
            if ("debugSamplingRate" in options) {
                this.appInsights = new applicationinsights_web_1.ApplicationInsights({
                    config: {
                        instrumentationKey: options.instrumentationKey,
                        maxBatchInterval: 0,
                        disableAjaxTracking: true,
                        disableFetchTracking: true,
                        samplingPercentage: (_a = options.debugSamplingRate) !== null && _a !== void 0 ? _a : 1,
                    },
                });
            }
            else {
                const reactPlugin = new applicationinsights_react_js_1.ReactPlugin();
                this.appInsights = new applicationinsights_web_1.ApplicationInsights({
                    config: {
                        instrumentationKey: options.instrumentationKey,
                        maxBatchInterval: 0,
                        disableAjaxTracking: false,
                        disableFetchTracking: false,
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        extensions: [reactPlugin],
                        extensionConfig: {
                            [reactPlugin.identifier]: {
                                history: options.browserHistory,
                            },
                        },
                    },
                });
            }
        }
        catch (err) {
            const originalException = err instanceof Error ? err : null;
            Log.info("AppInsights initialisation error", originalException ? { originalException } : undefined);
        }
        if (this.appInsights) {
            this.appInsights.loadAppInsights();
        }
        else {
            Log.info("AppInsights was not initialised (reason: unknown)");
        }
    }
    next(logEntry) {
        if (this.appInsights && this.shouldHandleLogEntry(logEntry)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const properties = Object.assign({}, logEntry.tags);
            if (logEntry.contexts !== undefined) {
                logEntry.contexts.forEach((ctx) => (properties[ctx.name] = ctx.data));
            }
            if (logEntry.message instanceof Error) {
                this.appInsights.trackException({
                    exception: logEntry.message,
                    properties,
                });
            }
            else {
                this.appInsights.trackTrace({
                    message: logEntry.message,
                    severityLevel: types_1.LogLevels[logEntry.level],
                    properties,
                });
            }
        }
    }
}
exports.AppInsightsSink = AppInsightsSink;
//# sourceMappingURL=AppInsightsSink.js.map